import React from "react";
import { Box } from "@material-ui/core";
import UserDetail from "../UserDetail/UserDetail";
import appBarUserDetailsStyles from "./AppBarUserDetailsStyles";
import { useTenant } from "../../Context/TenantProvider";
import AustraliaFilled from "../../IconComponents/AustraliaFilled";
import NewZealandFilled from "../../IconComponents/NewZealandFilled";

const AppBarUserDetails: React.FC<{ logout: () => Promise<void> }> = (props) => {
	const { logout } = props;
	const classes = appBarUserDetailsStyles();

	const { currentCountry } = useTenant();
	const countryImage = currentCountry.toUpperCase() === "AU" ? <AustraliaFilled size={"m"}/> : <NewZealandFilled size={"m"}/>;

	return (
		<Box className={classes.container}>
			{countryImage}
			<UserDetail logout={logout} />
		</Box>
	);
};
export default AppBarUserDetails;
